import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createStaticVNode("<defs><clipPath id=\"vote-positive-filled-alternate-clip_1\"><path d=\"M13.136 2.165C10.25.077 7.895 3.748 7.895 3.748S5.54.078 2.653 2.165C-3.067 6.302 7.895 15 7.895 15s10.962-8.698 5.241-12.835\" clip-rule=\"evenodd\"></path></clipPath><clipPath id=\"vote-positive-filled-alternate-clip_2\"><path d=\"M0 16h16V0H0Z\"></path></clipPath></defs><g clip-path=\"url(#vote-positive-filled-alternate-clip_1)\"><g clip-path=\"url(#vote-positive-filled-alternate-clip_2)\"><path fill=\"#298439\" d=\"M-4-3.477h23.79V20H-4Z\"></path></g></g>", 2)
  ]))]))
}
export default { render: render }